import { createAsyncThunk, createSlice, ActionReducerMapBuilder } from '@reduxjs/toolkit';
import axios from 'axios';
import { IDocument } from '../../../../interfaces';
import store from '../../../app/Store';

const VENDOR_MC_URL = `${process.env.REACT_APP_API_PIM_URL}/vendor`;

interface IState {
  data: IDocument[];
  loading: boolean;
  done: boolean;
  showError: boolean;
  error: any;
}

const initialState: IState = {
  data: [],
  loading: false,
  done: false,
  error: null,
  showError: false,
};

export const getVendorDocs = createAsyncThunk('document/list', async () => {
  const {
    auth: { user },
  } = store.getState();
  const res = await axios.get<IDocument[]>(`${VENDOR_MC_URL}/${user?.vendor?.id}/document`);
  return res.data;
});

const documentSlice = createSlice({
  name: 'document',
  initialState,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<IState>) => {
    builder.addCase(getVendorDocs.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getVendorDocs.fulfilled, (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.done = true;
    });
    builder.addCase(getVendorDocs.rejected, (state, action) => {
      state.loading = false;
      state.showError = true;
      state.error = 'Hata! Belgeler bulunamadı';
    });
  },
});
export default documentSlice.reducer;
